import { SelectionModel } from "@angular/cdk/collections";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTable, MatTableDataSource } from "@angular/material";
import { CrudFieldsService } from "../crud-fields/crud-fields.service";
import { DecimalPipe } from "@angular/common";

@Component({
  selector: "app-crud-import-fields",
  templateUrl: "./crud-import-fields.component.html",
  styleUrls: ["./crud-import-fields.component.scss"],
})
export class CrudImportFieldsComponent implements OnInit {
  @Input() displayedColumns: string[];
  @Input() receivedFieldsData: any;
  @Input() columnsFields: any[] = [];
  @Output() selectionChange = new EventEmitter();
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  selection = new SelectionModel<any>(true, []);
  mSort: any;
  decimal: any;
  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    this.mSort = sort;
  }

  pageIndex = 0;
  pageSize = 25;
  length: any;

  public selectedLineMenu: any;
  public selectedLineId: any;

  triggerFilter: boolean;
  displayFilter: boolean;

  constructor(
    private FieldsService: CrudFieldsService,
  ) {
    this.triggerFilter = false;
    this.displayFilter = FieldsService.statusFilter;
  }

  ngOnInit() {
    var decimalPipe = new DecimalPipe(navigator.language);

    this.paginator._intl.itemsPerPageLabel = "Itens por página: ";
    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      const start = page * pageSize + 1;
      const endPageSize = (page + 1) * pageSize;
      const end =
        length < endPageSize ? decimalPipe.transform(length) : endPageSize;

      return `${start} - ${end} de ${decimalPipe.transform(length)}`;
    };
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.sort = this.mSort;
    }
  }

  ngOnChanges() {
    if (
      (this.columnsFields !== undefined || this.columnsFields !== null) &&
      this.receivedFieldsData !== undefined
    ) {
      this.dataSource = new MatTableDataSource(this.receivedFieldsData);
      this.displayedColumns = ['select', ...this.columnsFields.map((x) => x.columnDef)];
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.mSort;
      if (this.dataSource.paginator) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.paginator.pageSize = this.pageSize;
        this.dataSource.paginator.pageIndex = this.pageIndex;
      }
      this.FieldsService.rowsCrud(
        this.dataSource,
        this.receivedFieldsData,
        this.table,
        this.paginator,
      );
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: { id: number }): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.id + 1}`;
  }

  ngOnDestroy(): void {
    this.FieldsService.statusFilterDefault.next(false);
  }

  saveSelectedLineMenu(row) {
    this.selectedLineMenu = row;
    this.selectedLineId = row.id;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  emitirSelecao() {
    this.selectionChange.emit(this.selection.selected);
  }
}
